const LoadingComp = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
}
export default LoadingComp